// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage"; // Import storage

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAiOxCKhdUfzpeyZSWTfmsyvuS74ltdUvY",
  authDomain: "sourcecodey-web.firebaseapp.com",
  projectId: "sourcecodey-web",
  storageBucket: "sourcecodey-web.firebasestorage.app",
  messagingSenderId: "52965796106",
  appId: "1:52965796106:web:d3ec9c69193e42997472f3",
  measurementId: "G-X3DX6EEPTB"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app); // Initialize and export storage
export const analytics = getAnalytics(app); // Initialize and export storage
